import ComingSoon from './ComingSoon';

export default function MembershipForum() {
  return <ComingSoon title="Üzvlük forumu" />;
}
